import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 16\" id=\"arrow-up\"><path d=\"M3 3.99V16h2V3.99h3L4 0 0 3.99z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol